import styled, { css } from 'styled-components';
import { Check, X } from '@olxbr/ds-icons';
import { Text } from '../Text';
const ICONS_SIZE = '16px';
const ICONS_PADDING_POSITION = '4px';
const SWITCH_ICON_SIZE = '20px';
const TOGGLE_SWITCH_HEIGHT = '24px';
const TOGGLE_SWITCH_WIDTH = '48px';
const TOGGLE_SWITCH_PADDING = '2px';
export const Label = styled(Text.BodyMedium) `
  margin-right: var(--spacing-1);
`;
export const CheckedIcon = styled(Check) `
  height: ${ICONS_SIZE};
  width: ${ICONS_SIZE};
  position: absolute;
  left: ${ICONS_PADDING_POSITION};
  top: ${ICONS_PADDING_POSITION};
  color: var(--toggleswitch-icon-color);
  visibility: hidden;
`;
export const UncheckedIcon = styled(X) `
  height: ${ICONS_SIZE};
  width: ${ICONS_SIZE};
  position: absolute;
  right: ${ICONS_PADDING_POSITION};
  top: ${ICONS_PADDING_POSITION};
  color: var(--toggleswitch-icon-color);
  visibility: hidden;
`;
export const NativeInput = styled.input.attrs(() => ({
    type: 'checkbox',
})) `
  position: absolute;
  opacity: 0;
  width: 1px;
  height: 1px;
`;
export const SwitchIcon = styled.span `
  display: inline-block;
  height: ${SWITCH_ICON_SIZE};
  width: ${SWITCH_ICON_SIZE};
  border-radius: var(--border-radius-pill);
  background-color: var(--toggleswitch-icon-color);
  position: absolute;
  transition: inherit;
`;
export const ToggleSwitchStylized = styled.span `
  display: inline-block;
  position: relative;
  flex-shrink: 0;
  width: ${TOGGLE_SWITCH_WIDTH};
  height: ${TOGGLE_SWITCH_HEIGHT};
  border: none;
  background-color: var(--toggleswitch-background-color-base);
  border-radius: var(--border-radius-pill);
  padding: ${TOGGLE_SWITCH_PADDING};
  transition: all 150ms ease-in-out;
`;
const withToggleBackground = () => css `
  ${NativeInput}:checked + ${ToggleSwitchStylized} {
    background-color: var(--toggleswitch-background-color-checked);
  }

  ${NativeInput}:not(:checked):not(:disabled):hover + ${ToggleSwitchStylized} {
    background-color: var(--toggleswitch-background-color-hover);
  }

  ${NativeInput}:checked:not(:disabled):hover + ${ToggleSwitchStylized} {
    background-color: var(--toggleswitch-background-color-checked-hover);
  }
`;
const withToggleEffects = () => css `
  ${NativeInput}:checked + ${ToggleSwitchStylized} ${SwitchIcon} {
    transform: translateX(24px);
  }

  ${NativeInput}:focus + ${ToggleSwitchStylized} {
    outline: var(--border-width-thin) solid var(--color-neutral-130);
    outline-offset: var(--border-width-thin);
  }
`;
export const ToggleSwitchWrapper = styled.label `
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  cursor: pointer;
  width: ${({ isLabelVisible }) => (isLabelVisible ? '100%' : 'fit-content')};

  ${withToggleBackground}
  ${withToggleEffects}

  ${NativeInput}:checked + ${ToggleSwitchStylized} ${CheckedIcon} {
    visibility: visible;
  }

  ${NativeInput}:not(:checked) + ${ToggleSwitchStylized} ${UncheckedIcon} {
    visibility: visible;
  }

  ${({ disabled }) => disabled &&
    `
      opacity: var(--opacity-medium);
      cursor: not-allowed;
    `}
`;
